/**
 * validateInput
 * @param $input {JQuery} ..
 * @returns void
 */
export function validateInput($input: JQuery) {
  try {
    if (!$input || !$input.length) {
      return;
    }
    const regexOpenTag = /<script/gi;
    const regexCloseTag = /<\/script/gi;
    let value: any = $input.val();
    if (regexOpenTag.test(value) || regexOpenTag.test(value)) {
      value = value.replace(regexOpenTag, '< script').replace(regexCloseTag, '</ script');
      $input.attr('value', value).val(value);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[GemPages] Error catch: ', error);
  }
}
